export function GmailIcon() {
  return (
    <svg width="25" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.935 14.33 3.418 8.273a2.25 2.25 0 0 1 2.415-3.795l6.983 4.443 6.27-4.389a2.25 2.25 0 0 1 2.58 3.686l-8.73 6.112Z"
        fill="#EA4435"
      />
      <path d="M21.125 19.876h-3v-13.5a2.25 2.25 0 0 1 4.5 0v12a1.5 1.5 0 0 1-1.5 1.5Z" fill="#00AC47" />
      <path
        d="M22.592 6.05c-.006-.046-.006-.092-.015-.137-.015-.069-.041-.132-.062-.199a2.205 2.205 0 0 0-.072-.224c-.015-.036-.038-.067-.055-.102a2.24 2.24 0 0 0-.162-.288c-.03-.044-.067-.08-.1-.122a2.267 2.267 0 0 0-.184-.214c-.05-.048-.107-.089-.161-.132a2.26 2.26 0 0 0-.18-.14c-.06-.039-.125-.068-.188-.102-.066-.034-.131-.072-.2-.1-.067-.026-.138-.043-.207-.064-.07-.02-.14-.045-.21-.058a2.294 2.294 0 0 0-.269-.027c-.057-.004-.113-.014-.17-.014a2.234 2.234 0 0 0-.317.032c-.042.007-.084.006-.126.015-.142.043-.283.087-.424.133-.038.017-.072.041-.11.06a2.176 2.176 0 0 0-1.255 2.008v4.322l3.54-2.479a2.166 2.166 0 0 0 .927-2.169Z"
        fill="#FFBA00"
      />
      <path
        d="M4.625 4.125a2.25 2.25 0 0 1 2.25 2.25v13.5h-3a1.5 1.5 0 0 1-1.5-1.5v-12a2.25 2.25 0 0 1 2.25-2.25Z"
        fill="#4285F4"
      />
      <path
        d="M2.408 6.05c.006-.046.006-.092.015-.137.015-.069.041-.132.062-.199.02-.076.044-.15.072-.224.015-.036.038-.067.055-.102.047-.1.1-.196.162-.288.03-.044.067-.08.1-.122a2.27 2.27 0 0 1 .184-.214c.05-.048.107-.089.161-.132a2.25 2.25 0 0 1 .18-.14c.06-.039.125-.069.188-.102.065-.036.132-.07.2-.1.067-.027.138-.044.208-.064.07-.02.139-.045.21-.059.089-.014.178-.023.268-.027.057-.004.113-.014.17-.013.106.003.212.014.317.032.042.006.084.005.126.014.073.019.145.04.215.067.07.019.14.04.209.067.038.016.072.04.11.06.097.045.19.098.28.157a2.246 2.246 0 0 1 .975 1.851v4.322l-3.54-2.479a2.167 2.167 0 0 1-.927-2.169Z"
        fill="#C52528"
      />
    </svg>
  );
}
